var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2:25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.002 5.5C6.002 5.89782 5.84396 6.27936 5.56266 6.56066C5.28135 6.84196 4.89982 7 4.502 7C4.10417 7 3.72264 6.84196 3.44134 6.56066C3.16003 6.27936 3.002 5.89782 3.002 5.5C3.002 5.10218 3.16003 4.72064 3.44134 4.43934C3.72264 4.15804 4.10417 4 4.502 4C4.89982 4 5.28135 4.15804 5.56266 4.43934C5.84396 4.72064 6.002 5.10218 6.002 5.5V5.5Z",
    fill: "black",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.002 1C1.47157 1 0.962858 1.21071 0.587785 1.58579C0.212713 1.96086 0.0019989 2.46957 0.0019989 3V13C0.0019989 13.5304 0.212713 14.0391 0.587785 14.4142C0.962858 14.7893 1.47157 15 2.002 15H14.002C14.5324 15 15.0411 14.7893 15.4162 14.4142C15.7913 14.0391 16.002 13.5304 16.002 13V3C16.002 2.46957 15.7913 1.96086 15.4162 1.58579C15.0411 1.21071 14.5324 1 14.002 1H2.002V1ZM14.002 2C14.2672 2 14.5216 2.10536 14.7091 2.29289C14.8966 2.48043 15.002 2.73478 15.002 3V9.5L11.225 7.553C11.1312 7.50602 11.025 7.48973 10.9215 7.50642C10.8179 7.52311 10.7223 7.57194 10.648 7.646L6.938 11.356L4.278 9.584C4.18196 9.52006 4.06676 9.4913 3.95194 9.5026C3.83711 9.5139 3.72973 9.56456 3.648 9.646L1.002 12V3C1.002 2.73478 1.10736 2.48043 1.29489 2.29289C1.48243 2.10536 1.73678 2 2.002 2H14.002Z",
    fill: "black",
    fillOpacity: 0.31
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2:25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.86dee7a46ca029b9a3f993364d74c421.svg";
export { ForwardRef as ReactComponent };